import type { SVGProps } from "react";

export function IconPurpleLotOfCash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.3335 44.6667V20.6667C9.3335 19.5621 10.2289 18.6667 11.3335 18.6667H26.1335H34.5335H49.3335C50.4381 18.6667 51.3335 19.5621 51.3335 20.6667V44.6667C51.3335 45.7713 50.4381 46.6667 49.3335 46.6667H34.5335H26.1335H11.3335C10.2289 46.6667 9.3335 45.7713 9.3335 44.6667Z"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.1665 32.69L43.1898 32.6641"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 32.69L17.5233 32.6641"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3335 37.3333H4.3335C3.22893 37.3333 2.3335 36.4379 2.3335 35.3333V11.3333C2.3335 10.2287 3.22893 9.33331 4.3335 9.33331H42.3335C43.4381 9.33331 44.3335 10.2287 44.3335 11.3333V18.6666"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3333 37.3333C27.756 37.3333 25.6667 35.244 25.6667 32.6667C25.6667 30.0893 27.756 28 30.3333 28C32.9107 28 35 30.0893 35 32.6667C35 35.244 32.9107 37.3333 30.3333 37.3333Z"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
